import { appLink } from '@experience/core-app-link-lib';
import { initWebComponent } from '@experience/vite-plugin-wc-extract-styles';
import { createPinia } from 'pinia';
import { defineCustomElement } from 'vue';
import { createWebHistory, createRouter, createRouterMatcher, type RouterScrollBehavior } from 'vue-router';
import App from '@/App.ce.vue';
import { defaultRoutes } from '@/router';
import { createHead } from '@unhead/vue/client';

import { MF_NAME } from '@/const';

const matcher = createRouterMatcher(defaultRoutes, {});

const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  }

  if (to.hash) {
    return { el: to.hash, behavior: 'smooth' };
  }

  return { left: 0, top: 0, behavior: 'smooth' };
};

export default initWebComponent({
  elementName: MF_NAME,
  stylesUrl: new URL(`${window.location.origin}/mfs/${MF_NAME}/extracted-styles.css`),
  dev: import.meta.env.DEV,

  defineElement: (styles) =>
    defineCustomElement(App, {
      styles,
      configureApp(app) {
        app.use(appLink({ matcher, hostAppRouterName: '__HOST_APP_ROUTER__' }));
        app.use(createPinia());
        app.use(createHead());

        const router = createRouter({
          history: createWebHistory('/help-center/'),
          routes: defaultRoutes,
          scrollBehavior,
        });

        app.use(router);
      },
    }),
});
